'use client';
import React from 'react';
import Image from 'next/image';

export default function HeroSection() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ minHeight: 'clamp(520px, 80vh, 900px)', backgroundColor: '#1A2332' }}
    >
      {/* Full-bleed background image — served as WebP via Next.js Image optimisation */}
      <div className="absolute inset-0">
        <Image
          src="/assets/images/0a75ee2b-cb4c-4006-bee6-d90bd0e7b376-1782060666664.png"
          alt=""
          fill
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 100vw, 1335px"
          quality={80}
          priority
          className="object-cover"
          style={{ objectPosition: '50% 40%', opacity: 0.45 }}
        />
        {/* Gradient overlay — dark at bottom, lighter at top */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(160deg, rgba(26,35,50,0.3) 0%, rgba(26,35,50,0.7) 60%, rgba(26,35,50,0.92) 100%)',
          }}
        />
      </div>

      {/* Content — asymmetric left-aligned */}
      <div
        className="relative z-10 flex flex-col justify-center items-center text-center"
        style={{
          minHeight: 'clamp(520px, 80vh, 900px)',
          padding: 'clamp(40px, 6vw, 96px) clamp(24px, 6vw, 96px)',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {/* Main heading */}
        <h1
          className="animate-fade-in animate-delay-100"
          style={{
            fontFamily: 'orpheus-pro, Georgia, serif',
            fontSize: 'clamp(24px, 3.5vw, 52px)',
            fontWeight: '400',
            color: '#E8D8D5',
            lineHeight: '1.2',
            maxWidth: '860px',
            marginBottom: '16px',
          }}
        >
          Private Clinical Psychology Services
        </h1>
        {/* Subtitle */}
        <p
          className="animate-fade-in animate-delay-200"
          style={{
            fontFamily: 'orpheus-pro, Georgia, serif',
            fontSize: 'clamp(14px, 1.6vw, 22px)',
            fontWeight: '400',
            color: '#E8D8D5',
            opacity: 0.85,
            lineHeight: '1.4',
            maxWidth: '860px',
            marginBottom: '40px',
          }}
        >
          Dr Jennifer Morgan, Consultant Clinical Psychologist (BA Hons · MSc · DClinPsych(Oxon) · DipCAT · Cpsychol)
        </p>

        {/* CTA row */}
        <div className="flex flex-col sm:flex-row gap-4 animate-fade-in animate-delay-300 justify-center">
          <a
            href="/contact"
            style={{
              fontFamily: 'adobe-garamond-pro, Georgia, serif',
              fontSize: '13px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#1A2332',
              backgroundColor: '#E8D8D5',
              padding: '15px 36px',
              textDecoration: 'none',
              display: 'inline-block',
              transition: 'background-color 0.25s ease',
            }}
            onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#DFD0CC')}
            onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#E8D8D5')}
          >
            Arrange a Consultation
          </a>
          <a
            href="/about"
            style={{
              fontFamily: 'adobe-garamond-pro, Georgia, serif',
              fontSize: '13px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#E8D8D5',
              backgroundColor: 'transparent',
              padding: '14px 35px',
              textDecoration: 'none',
              display: 'inline-block',
              border: '1px solid rgba(245,240,234,0.4)',
              transition: 'border-color 0.25s ease, background-color 0.25s ease',
            }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLElement).style.borderColor = 'rgba(245,240,234,0.8)';
              (e.currentTarget as HTMLElement).style.backgroundColor = 'rgba(245,240,234,0.08)';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLElement).style.borderColor = 'rgba(245,240,234,0.4)';
              (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent';
            }}
          >
            About Dr Morgan
          </a>
        </div>

        {/* Credentials strip */}
        <div
          className="animate-fade-in animate-delay-400"
          style={{
            marginTop: 'clamp(40px, 5vw, 72px)',
            paddingTop: '20px',
            borderTop: '1px solid rgba(245,240,234,0.12)',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '24px',
            justifyContent: 'center',
          }}
        >
          {['HCPC Registered', 'BPS Chartered', 'Oxford DClinPsy', '20+ Years Experience'].map(cred => (
            <span
              key={cred}
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '12px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: 'rgba(239,227,225,0.4)',
              }}
            >
              {cred}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
